import React from 'react';
import styled from 'styled-components';
import icon1 from '../../../styles/images/icon-1.png';
import icon2 from '../../../styles/images/icon-2.png';
import icon3 from '../../../styles/images/icon-3.png';
import icon4 from '../../../styles/images/icon-4.png';
import icon5 from '../../../styles/images/icon-5.png';
import icon6 from '../../../styles/images/icon-6.png';
import icon7 from '../../../styles/images/icon-7.png';
import Row from './Row';
import Ribbon from '../Ribbon';
import i18n from '../../../config/i18n';

const H3 = styled.h3`
  color: #6AE2CE;
  font-size: 34px;
  font-weight: 700;
  padding: 0;
  margin: 0;
`;

const Num = styled.span`
  font-size: 54px !important;
`;

const P = styled.p`
  color: #4C7196;
  font-size: 24px;
  font-weight: 500;
  padding-top: 20px;

  @media screen and (max-width: 813px) {
    text-align: center;
    font-size: 18px;
    text-align: center;
  }
`;

const Icon = styled.img`
  margin-right: 20px;
`;

const StyledWrap = styled.div`
  margin: 0 auto;
  padding: 7em 0;
  overflow: hidden;
  font-family: "Open Sans", Arial, sans-serif;

  @media screen and (max-width: 768px) {
    padding: 4em 0;
  }
`;

class Statistics extends React.Component {
  state = {
    width: window.innerWidth,
  };

  componentDidMount() {
    window.addEventListener('resize', () => this.setState({ width: window.innerWidth }));
  }

  render() {
    const isMobile = this.state.width <= 812;
    return (
      <StyledWrap>
        <div className="container">
          <Row
            icon={<Icon src={icon1} width={190} />}
            isMobile={isMobile}
          >
            <H3>
              <Num>
                {i18n.t('whyUs_1_titleNum')}
              </Num>
              {i18n.t('whyUs_1_title')}
            </H3>
            <P>
              {i18n.t('whyUs_1_subTitle')}
            </P>
          </Row>

          <Row
            icon={<Icon src={icon2} width={120} />}
            textRight
            isMobile={isMobile}
          >
            <H3>
              <Num>
                {i18n.t('whyUs_2_titleNum')}
              </Num>
              {i18n.t('whyUs_2_title')}
            </H3>
            <P>
              {i18n.t('whyUs_2_subTitle')}
            </P>
          </Row>

          <Row
            icon={<Icon src={icon3} width={190} />}
            isMobile={isMobile}
          >
            <H3>
              <Num>
                {i18n.t('whyUs_3_titleNum')}
              </Num>
              {i18n.t('whyUs_3_title')}
            </H3>
            <P>
              {i18n.t('whyUs_3_subTitle')}
            </P>
          </Row>

          <Row
            icon={<Icon src={icon4} width={171} />}
            textRight
            isMobile={isMobile}
          >
            <H3>
              <Num>
                {i18n.t('whyUs_4_titleNum')}
              </Num>
              {i18n.t('whyUs_4_title')}
            </H3>
            <P>
              {i18n.t('whyUs_4_subTitle')}
            </P>
          </Row>

          <Row
            icon={<Icon src={icon5} width={190} />}
            isMobile={isMobile}
          >
            <H3>
              <Num>
                {i18n.t('whyUs_5_titleNum')}
              </Num>
              {i18n.t('whyUs_5_title')}
            </H3>
            <P>
              {i18n.t('whyUs_5_subTitle')}
            </P>
          </Row>

          <Row
            icon={<Icon src={icon6} width={190} />}
            textRight
            isMobile={isMobile}
          >
            <H3>
              <Num>
                {i18n.t('whyUs_6_titleNum')}
              </Num>
              {i18n.t('whyUs_6_title')}
            </H3>
            <P>
              {i18n.t('whyUs_6_subTitle')}
            </P>
          </Row>

          <Row
            icon={<Icon src={icon7} width={190} />}
            isMobile={isMobile}
          >
            <H3>
              <Num>
                {i18n.t('whyUs_7_titleNum')}
              </Num>
              {i18n.t('whyUs_7_title')}
            </H3>
            <P>
              {i18n.t('whyUs_7_subTitle')}
            </P>
          </Row>
        </div>
        <Ribbon />
      </StyledWrap>
    );
  }
}

export default Statistics;



// WEBPACK FOOTER //
// ./src/components/landing/Statistics/index.js